module.exports = __webpack_public_path__ + "static/media/last-widge-color.bb0d09c5.svg";